/**
 * Cart Rewards Bar
 *
 * Companion element for snippets/cart-rewards-bar.liquid. The bar is
 * server-rendered and replaced wholesale on every cart mutation, so instances
 * are short-lived; the static lastReachedCount survives the swaps and lets a
 * newly rendered instance detect that the shopper just crossed a tier
 * threshold. Crossing announces the rendered reached-message through the cart
 * live region (WCAG 4.1.3); the compare-and-set on the static keeps duplicate
 * instances (drawer + /cart page) from double-announcing.
 */

class CartRewardsBar extends HTMLElement {
	static lastReachedCount = null;

	connectedCallback() {
		const count = parseInt(this.dataset.reachedCount, 10) || 0;
		const previous = CartRewardsBar.lastReachedCount;
		CartRewardsBar.lastReachedCount = count;

		if (previous === null || count <= previous) {
			return;
		}

		const message = this.dataset.reachedMessage;
		if (message) {
			// priority: a crossing announcement is the one thing here a shopper must not
			// miss, and a burst of routine cart chatter used to evict it from the queue.
			window.UFT?.CartStatusAnnouncer?.announce?.(message, { priority: true });
		}
	}
}

if (!customElements.get('cart-rewards-bar')) {
	customElements.define('cart-rewards-bar', CartRewardsBar);
}
